<template>
<section aria-label="Enthaltene Formulare">
    <p class="text-muted">Die Zuordnung gehört zur globalen Paketdefinition. Bestehende Buchungen behalten ihre enthaltenen Formulare. Mehrfach enthaltene Formulare werden einmal freigeschaltet.</p>
    <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>
    <label>Formularpaket</label><select class="form-control mb-3" v-model="packageId" @change="load" :disabled="busy"><option value="">Paket auswählen</option><option v-for="p in packages" :key="field(p,'PackageId')" :value="field(p,'PackageId')">{{ field(p,'Title') }}</option></select>
    <div v-if="packageId"><table class="table"><thead><tr><th>Formular</th><th>Status</th><th>Aktion</th></tr></thead><tbody><tr v-for="row in rows" :key="field(row,'PackageFormId')"><td>{{ field(row,'FormName') }}</td><td>{{ field(row,'IsActive') ? 'Enthalten' : 'Inaktiv' }}</td><td><button type="button" class="btn btn-sm btn-outline-primary" :disabled="busy" @click="save(row)">{{ field(row,'IsActive') ? 'Deaktivieren' : 'Aktivieren' }}</button></td></tr></tbody></table>
    <label>Formular hinzufügen</label><select class="form-control mb-2" v-model="formId" :disabled="busy"><option value="">Formular auswählen</option><option v-for="f in forms.filter(f => !rows.some(r => field(r,'FormId') === field(f,'FormId')))" :key="field(f,'FormId')" :value="field(f,'FormId')">{{ field(f,'FormName') }}</option></select><button type="button" class="btn btn-primary" :disabled="busy || !formId" @click="save(null)">Hinzufügen</button></div>
    <p v-if="busy" role="status">Wird geladen …</p>
  </section>
</template>
<script>
import axios from 'axios';
import config from '../../config/config';
import { joinApiUrl } from '../../config/api-url';
const field = (row, name) => row[name] ?? row[name[0].toLowerCase() + name.slice(1)];
const endpoint = path => joinApiUrl(config.API_URL, 'api/admin/packages' + path);
const options = () => ({ headers: { Authorization: 'Bearer ' + (window.getOzgUserToken?.() || localStorage.getItem('ozgUserJwt') || localStorage.getItem('ozgJwt') || '') } });
export default {
  data: () => ({ packages: [], forms: [], rows: [], packageId: '', formId: '', busy: false, error: '', generation: 0 }),
  async created() {
    this.busy = true;
    try {
      const [packages, forms] = await Promise.all([axios.get(endpoint(''), options()), axios.get(endpoint('/form-options'), options())]);
      this.packages = packages.data.filter(p => field(p, 'PackageType') === 'FORM_BUNDLE');
      this.forms = forms.data;
    } catch (e) { this.error = e.response?.data?.message || 'Formularpakete konnten nicht geladen werden.'; }
    finally { this.busy = false; }
  },
  methods: {
    field,
    async load() {
      const generation = ++this.generation;
      const packageId = this.packageId;
      this.rows = []; this.error = ''; this.formId = '';
      if (!packageId) return;
      this.busy = true;
      try {
        const response = await axios.get(endpoint('/' + packageId + '/forms'), options());
        if (generation === this.generation) this.rows = response.data;
      } catch (e) { if (generation === this.generation) this.error = e.response?.data?.message || 'Enthaltene Formulare konnten nicht geladen werden.'; }
      finally { if (generation === this.generation) this.busy = false; }
    },
    async save(row) {
      if (this.busy || !this.packageId || (!row && !this.formId)) return;
      this.busy = true; this.error = '';
      try {
        const dto = row ? { PackageFormId: field(row,'PackageFormId'), FormId: field(row,'FormId'), SortOrder: field(row,'SortOrder'), IsActive: !field(row,'IsActive'), RowVersion: field(row,'RowVersion') }
          : { FormId: Number(this.formId), SortOrder: this.rows.length, IsActive: true };
        if (row) await axios.put(endpoint('/' + this.packageId + '/forms/' + dto.PackageFormId), dto, options());
        else await axios.post(endpoint('/' + this.packageId + '/forms'), dto, options());
        await this.load();
      } catch (e) { this.error = e.response?.data?.message || 'Änderung konnte nicht gespeichert werden. Bitte neu laden.'; }
      finally { this.busy = false; }
    }
  }
};
</script>
